import { useState, useEffect } from "react";
import request from "project-config/services/request/request";
import { useLotteryStore } from "../store/lottery-store";
import { ActivityTypeCode } from "project-config/constants/activity-code";
import { BindActivityInfo } from "@/components/top-up/types";

export interface LotteryActivityInfoList {
  [key: string]: string | number;
  ticketCode: string;
  remark: string;
  receivingInfo: string;
  prizeType: number;
  payRecordId: string;
  activityId: number;
  status: number;
  startTime: number;
  endTime: number;
}

export function useFetchLotteryActivityInfoList() {
  const [loading, setLoading] = useState(false);
  const [luckDrawGiftActivityInfo, setLuckDrawGiftActivityInfo] =
    useState<BindActivityInfo>();
  const [lotteryActivityInfoList, setLotteryActivityInfoList] = useState<
    LotteryActivityInfoList[]
  >([]);
  const [showCashActivityEntry, setshowCashActivityEntry] = useState(false);
  const [lottryActivityRules, setLottryActivityRules] = useState({
    rulesCN: "",
    rulesEN: ",",
  });
  const { setCurrentActivityID } = useLotteryStore();

  const getClaimPrizeInfo = async (
    luckDrawGiftActivityInfo1?: BindActivityInfo
  ) => {
    if (luckDrawGiftActivityInfo1) {
      await queryYearEndActivity({}, luckDrawGiftActivityInfo1);
      return;
    }
    const { code, data } = await request.post(
      "/api/rendering/pay/activity/template/claimPrizeInfo"
    );
    if (code === 200 && data && data.activityId) {
      setLottryActivityRules({
        rulesCN: data.rulesCN,
        rulesEN: data.rulesEN,
      });
      await queryYearEndActivity(data, luckDrawGiftActivityInfo1);
      return;
    }
    if (!luckDrawGiftActivityInfo1) return;
    intiLotteryPrize();
  };

  const queryYearEndActivity = async (
    result: any,
    luckDrawGiftActivityInfo1?: BindActivityInfo
  ) => {
    const params = luckDrawGiftActivityInfo1
      ? luckDrawGiftActivityInfo1?.id
      : result.activityId;
    if (!params) return;
    const { code, data } = await getLotteryPrize(params);
    function sortActivityInfoList(
      a: LotteryActivityInfoList,
      b: LotteryActivityInfoList
    ) {
      return a.prizeType - b.prizeType;
    }
    setLotteryActivityInfoList(
      [
        ...data
          .filter((item: LotteryActivityInfoList) => item.prizeType)
          .sort(sortActivityInfoList),
        ...data.filter((item: LotteryActivityInfoList) => !item.prizeType),
      ] || []
    );
    if (code !== 200) {
      setshowCashActivityEntry(false);
      return;
    }
    setshowCashActivityEntry(!!!luckDrawGiftActivityInfo1);
  };
  const getLotteryPrize = async (
    activityId?: number,
    luckDrawGiftActivityInfo1?: BindActivityInfo
  ) => {
    setCurrentActivityID(luckDrawGiftActivityInfo1?.id || activityId || 0);
    if (!activityId && !luckDrawGiftActivityInfo1?.id)
      return { data: undefined };
    const { data, code } = await request.post(
      "/api/rendering/user/activity/template/getUserPrizeCode",
      { activityId: luckDrawGiftActivityInfo1?.id || activityId }
    );
    return { data, code };
  };

  const intiLotteryPrize = async () => {
    setshowCashActivityEntry(false);
    const { data } = await getLotteryPrize();
    setLotteryActivityInfoList(data || []);
  };

  const getActivityInfoList = async () => {
    setLoading(true);
    const { data } = await request.post(
      "/api/rendering/user/activity/template/getSupportActivity"
    );
    const luckDrawGiftActivityInfo = data
      ? data.find(
          (item: { activityType: ActivityTypeCode }) =>
            item.activityType === ActivityTypeCode.LuckyDrawGift
        )
      : data;
    setLuckDrawGiftActivityInfo(luckDrawGiftActivityInfo);
    await getClaimPrizeInfo(luckDrawGiftActivityInfo);
    setLoading(false);
  };

  useEffect(() => {
    getActivityInfoList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    lotteryActivityInfoList,
    setLotteryActivityInfoList,
    showCashActivityEntry,
    lottryActivityRules,
    luckDrawGiftActivityInfo,
    loading,
  };
}
